export default __webpack_public_path__ + "static/media/4948@2x.c64f3186.png";